import { useState } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";

export default function CameraController({ rb }) {
    const [smoothCameraPosition] = useState(() => new THREE.Vector3(10, 10, 10));
    const [smoothCameraTarget] = useState(() => new THREE.Vector3());

    useFrame((state, delta) => {
        if (rb.current) {
            const bodyPosition = rb.current.translation();
            const cameraPosition = new THREE.Vector3();
            cameraPosition.copy(bodyPosition);
            cameraPosition.z += 3.25;
            cameraPosition.y += 0.65;

            const cameraTarget = new THREE.Vector3();
            cameraTarget.copy(bodyPosition);
            cameraTarget.y += 0.25;

            smoothCameraPosition.lerp(cameraPosition, 5 * delta);
            smoothCameraTarget.lerp(cameraTarget, 5 * delta);

            state.camera.position.copy(smoothCameraPosition);
            state.camera.lookAt(smoothCameraTarget);
        }
    });

    return null;
}
